import { IKanbanState } from './kanban-states.store'
import { GetterTree } from 'vuex';

const getters: GetterTree<IKanbanState, {}> = <GetterTree<IKanbanState, {}>>{
    kanbanUrl: (state: IKanbanState) => state.kanbanUrl,
    kanbanAuthentication: (state: IKanbanState) => state.kanbanAuthentication,
}

export default getters;